module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_8-1.82bce130.png";